import { Card, Col, DatePicker, Form, Input, Row } from 'antd'

import { requiredRules } from 'src/app-constants'
import {
  dayMonthYearHourMinutesFormatWithDot,
  disabledFutureDate
} from 'src/libs'
import { useLocales } from 'src/locales'

export const EpidemiologyNotificationCard = () => {
  const { t } = useLocales()

  return (
    <Card title={t('epidemiology.notification')}>
      <Row gutter={[24, 24]}>
        <Col span={8}>
          <Form.Item
            name={['form', 'notification', 'epidemiologyNumber']}
            label={t('epidemiology.epidemiology_number')}
          >
            <Input placeholder={t('epidemiology.epidemiology_number')} />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            name={['form', 'notification', 'notifierFullName']}
            label={t('epidemiology.person_who_notified')}
            rules={requiredRules}
          >
            <Input placeholder={t('epidemiology.person_who_notified')} />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            name={['form', 'notification', 'notifiedAt']}
            label={t('epidemiology.notification_date_time')}
            rules={requiredRules}
          >
            <DatePicker
              className="full-width"
              showTime
              showSecond={false}
              needConfirm={false}
              format={dayMonthYearHourMinutesFormatWithDot}
              disabledDate={disabledFutureDate}
              placeholder={t('epidemiology.notification_date_time')}
            />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  )
}
